import type { InferOutput } from 'valibot'
import { array, literal, nullish, object, pipe, string, transform, union } from 'valibot'
import { relatedDocument, richTextData, singleImage, singleLineData } from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'
import {
  cardsSectionPiece,
  contentBlockPiece,
  ctaPiece,
  linkButtonPiece,
  quotePiece,
  statsPiece,
  testimonialsPiece,
  uspListPiece,
} from '~/utils/crystallize/pieces'

export const frontPageSchema = crystallizeDocumentSchema(
  'front-page',
  object({
    title: nullish(string()),
    headerImage: singleImage,
    leadParagraph: nullish(richTextData),
    topSectionAction: nullish(linkButtonPiece),
    secondaryTopSectionAction: nullish(linkButtonPiece),
    betaCta: nullish(
      pipe(
        array(object({
          title: nullish(singleLineData),
          text: nullish(richTextData),
        })),
        transform(it => it?.[0]),
      ),
    ),
    body: safeArray(
      union([
        object({
          type: literal('quote'),
          value: quotePiece,
        }),
        // FIXME: Remove when not present in Crystallize anymore
        object({
          type: literal('legacy-cta'),
          value: ctaPiece,
        }),
        object({
          type: literal('changes-article-cta'),
          value: ctaPiece,
        }),
        object({
          type: literal('products-cta'),
          value: contentBlockPiece,
        }),
        object({
          type: literal('usp-list'),
          value: uspListPiece,
        }),
        object({
          type: literal('event-cards'),
          value: cardsSectionPiece,
        }),
        object({
          type: literal('article-cards'),
          value: cardsSectionPiece,
        }),
        object({
          type: literal('testimonials'),
          value: testimonialsPiece,
        }),
        object({
          type: literal('stats'),
          value: statsPiece,
        }),
        object({
          type: literal('highlighted-article'),
          value: relatedDocument,
        }),
      ]),
    ),
  }),
)

export type FrontPageCmsData = InferOutput<typeof frontPageSchema>
